import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedRequestDetails: null
}

export const requestSlice = createSlice({
    name: "requests",
    initialState,
    reducers: {
        setSelectedRequestDetails: (state, action) => {
            state.selectedRequestDetails = action.payload
        },
    }
})

export const { setSelectedRequestDetails } = requestSlice.actions
export default requestSlice.reducer